import { delivery } from '~js/utils/delivery';

const storeLocater = {
  el: {},
  root: document,

  qs(selector, parent = storeLocater.root) {
    return parent.querySelector(selector);
  },

  qsAll(selector, parent = storeLocater.root) {
    return Array.from(parent.querySelectorAll(selector));
  },

  selectors: {
    buybox: '.js-buybox',
    deliverableContainer: '.js-product_delivarable',
    deliveringInfo: '.js-deliveringzip',
    locateMeContainer: '.js-product__locateMeContainer',
    ctas: '.js-product__locateMeCtas',
    autoCTA: '.js-locateme_auto_cta',
    manualContainer: '.js-locateme_manual_container',
    manualInputContainer: '.js-locateme_manual__input_container',
    zipInput: '.js-locateme_manual_input',
    manualCTA: '.js-locateme_manual_cta',
    availabilityText: '.js-availability_text',
  },

  init(parentElement) {
    this.root = parentElement;
    this.cacheElements();
    this.bindEvents();
  },

  cacheElements() {
    const s = this.selectors;
    this.el = {
      buybox: this.qs(s.buybox, document),
      locateMeContainer: this.qs(s.locateMeContainer),
      availabilityText: this.qs(s.availabilityText),
      ctas: this.qs(s.ctas),
      inputConatainer: this.qs(s.manualInputContainer),
    };

    if (this.el.ctas) {
      this.el.autoCTA = this.qs(s.autoCTA, this.el.ctas);
      this.el.manualContainer = this.qs(s.manualContainer, this.el.ctas);

      if (this.el.manualContainer) {
        this.el.zipInput = this.qs(s.zipInput, this.el.manualContainer);
        this.el.manualCTA = this.qs(s.manualCTA, this.el.manualContainer);
      }
    }
  },

  bindEvents() {
    this.el.autoCTA?.addEventListener('click', () => this.handleAutoLocate());
    this.el.manualCTA?.addEventListener('click', () =>
      this.handleManualLocate('pdp'),
    );
    this.el.zipInput?.addEventListener('input', () =>
      delivery.handleZipInputChange(this.el.zipInput, this.el.manualCTA),
    );
  },

  async handleManualLocate() {
    const input = this.el.zipInput?.value;
    const errorEl = this.qs('.js-locateme_manual_error');
    const spinnerEl = this.qs('.js-locateme_manual_spinner');
    const textEl = this.qs('.js-locateme_check_text');
    delivery.show(spinnerEl);
    delivery.hide(textEl);
    delivery.hide(errorEl);

    const isValidZip = /^\d{5,9}$/.test(input);
    if (!isValidZip) {
      delivery.show(errorEl);
    } else {
      try {
        const { zip, deliverable } =
          await delivery.handleLocateManualGeneric(input);
        if (deliverable === 'not-at-all') {
          delivery.redirectToNearestStoreFinder(zip);
          this.el.zipInput.value = '';
          this.el.manualCTA.disabled = true;
        } else if (deliverable === true) {
          delivery.hide(this.el.locateMeContainer);
          delivery.hide(this.el.ctas);
          this.toggleDeliverability({ zip, deliverable });
          delivery.hide(this.el.availabilityText);
          return true;
        } else if (deliverable === false) {
          delivery.redirectToLegacyBuyBox(zip);
          this.el.zipInput.value = '';
          this.el.manualCTA.disabled = true;
        }
      } catch (err) {
        console.error(err);
      }
    }
    delivery.hide(spinnerEl);
    delivery.show(textEl);
  },

  async handleAutoLocate() {
    const locateMeBtn = this.qs('.js-locateme_auto_cta');
    const spinnerEl = this.qs('.js-locateme_spinner');
    const orSpan = this.qs('.js-locateme_or');
    const detectionFailedErrorBlock = this.qs(
      '.js-locateme_error_detection_failed',
    );
    const accessDeniedErrorBlock = this.qs('.js-locateme_error_access_denied');

    if (!locateMeBtn || !orSpan) return;

    locateMeBtn.classList.add('is-locating');
    delivery.show(spinnerEl);

    try {
      const { zip, deliverable } = await delivery.handleLocateAutoGeneric();

      if (deliverable === 'not-at-all') {
        delivery.redirectToNearestStoreFinder(zip);
      } else if (deliverable === true) {
        delivery.hide(this.el.locateMeContainer);
        delivery.hide(this.el.ctas);
        this.toggleDeliverability({ zip, deliverable });
        delivery.hide(this.el.availabilityText);
        return true;
      } else if (deliverable === false) {
        delivery.redirectToLegacyBuyBox(zip);
      }
    } catch (err) {
      console.error('Auto locate failed:', err.message);
      delivery.hide(detectionFailedErrorBlock);
      delivery.hide(accessDeniedErrorBlock);

      if (err.code === 1) {
        delivery.show(accessDeniedErrorBlock); // PERMISSION_DENIED
      } else {
        delivery.show(detectionFailedErrorBlock); // POSITION_UNAVAILABLE
      }

      delivery.hide(locateMeBtn);
      delivery.hide(orSpan);
      delivery.hide(this.el.availabilityText);
    } finally {
      delivery.hide(spinnerEl);
      locateMeBtn.classList.remove('is-locating');
    }
  },

  toggleDeliverability({ zip, deliverable }) {
    const { deliverableContainer, deliveringInfo } = this.selectors;
    const isDeliverable = deliverable;
    const container = this.el.buybox
      ? this.qs(deliverableContainer, this.el.buybox)
      : null;
    const info = this.qs(deliveringInfo, container);
    const span = info?.querySelector('.zip-text');

    [container, this.el.locateMeContainer, info].forEach((el) => {
      delivery.toggle(el, 'is-delivarable', isDeliverable);
    });

    if (span) {
      delivery.setText(span, isDeliverable ? `${zip || ''}` : '');
    }
    delivery.updateZipInURL(zip);
  },

  hideAvailabilityText() {
    delivery.hide(this.el.availabilityText);
  },
};

export { storeLocater };
